export const ORG_TYPE_URL_SEGMENTS = [
  // en
  'nonprofit',
  'government',
  'consultant',
  'social-enterprise',
  'recruiter',
  'business',
  'community',
  // es
  'ong',
  'gobierno',
  'consultor',
  'empresa-social',
  'agencia-de-contratacion',
  'empresa',
  'colectivo-ciudadano',
  // pt
  // 'ong', already in es
  'governo',
  'consultoria',
  'empreendedorismo-social',
  'recrutador',
  // 'empresa', already in es
  'coletivos',
] as const;

export const JOB_URL_SEGMENTS = [
  'job', // en
  'empleo', // es
  'emprego', // pt
] as const;

export type CombinedOrgTypeAndJobUrlSegment =
  `${(typeof ORG_TYPE_URL_SEGMENTS)[number]}-${(typeof JOB_URL_SEGMENTS)[number]}`;

export const combinedOrgTypeAndJobUrlSegments = ORG_TYPE_URL_SEGMENTS.flatMap(
  (orgTypeSegment) =>
    JOB_URL_SEGMENTS.map(
      (jobUrlSegment) =>
        `${orgTypeSegment}-${jobUrlSegment}` satisfies CombinedOrgTypeAndJobUrlSegment,
    ),
);

export const INTERNSHIP_URL_SEGMENTS = [
  'internship', // en
  'pasantia', // es
  'estagio', // pt
] as const;

export type CombinedOrgTypeAndInternshipUrlSegment =
  `${(typeof ORG_TYPE_URL_SEGMENTS)[number]}-${(typeof INTERNSHIP_URL_SEGMENTS)[number]}`;

export const combinedOrgTypeAndInternshipUrlSegments =
  ORG_TYPE_URL_SEGMENTS.flatMap((orgTypeSegment) =>
    INTERNSHIP_URL_SEGMENTS.map(
      (internshipUrlSegment) =>
        `${orgTypeSegment}-${internshipUrlSegment}` satisfies CombinedOrgTypeAndInternshipUrlSegment,
    ),
  );

export const VOLOP_URL_SEGMENTS = [
  'volunteer-opportunity', // en
  'oportunidad-voluntariado', // es
  'oportunidade-voluntariado', // pt
] as const;

export const GRAD_PROGRAM_URL_SEGMENTS = [
  'grad-program', // en
  'programa-posgrado', // es
  'programa-posgraduacao', // pt
] as const;
